import { render } from "./management.cattle.io.project.vue?vue&type=template&id=c303fefe&scoped=true"
import script from "./management.cattle.io.project.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.project.vue?vue&type=script&lang=js"

import "./management.cattle.io.project.vue?vue&type=style&index=0&id=c303fefe&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c303fefe"]])

export default __exports__